import { useCallback, useReducer, useRef, useState } from 'react'
import { historyReducer } from '../reducers'

export default function useCanvasHistory(activeCanvas, currentEditTarget) {
  const ignoreHistoryRef = useRef(false)
  const [canvasHistory, dispatchHistory] = useReducer(historyReducer, {})
  const [disableUndo, setDisableUndo] = useState(false)

  const spineHistory = canvasHistory.canvases?.spine
  const frontHistory = canvasHistory.canvases?.front
  const backHistory = canvasHistory.canvases?.back

  const currentCanvasHistory = canvasHistory.canvases
    ? canvasHistory.canvases[currentEditTarget]
    : null

  const canUndo = currentCanvasHistory?.index > 0 && !disableUndo
  const canRedo =
    currentCanvasHistory?.index < currentCanvasHistory?.stack.length - 1 &&
    !disableUndo

  const undo = () => {
    if (ignoreHistoryRef.current) return

    const currHistory = canvasHistory.canvases[currentEditTarget]
    const newIndex = currHistory.index - 1
    ignoreHistoryRef.current = true

    activeCanvas
      .loadFromJSON(currHistory.stack[newIndex > 0 ? newIndex : 0])
      .then(() => {
        activeCanvas.renderAll()
        ignoreHistoryRef.current = false
      })

    dispatchHistory({ type: 'UNDO', activeCanvas: currentEditTarget })
  }

  const redo = () => {
    if (ignoreHistoryRef.current) return

    const currHistory = canvasHistory.canvases[currentEditTarget]

    const newIndex = currHistory.index + 1
    ignoreHistoryRef.current = true
    const newIndexOutOfBounds = newIndex >= currHistory.stack.length

    activeCanvas
      .loadFromJSON(
        currHistory.stack[
          newIndexOutOfBounds ? currHistory.stack.length - 1 : newIndex
        ],
      )
      .then(() => {
        activeCanvas.renderAll()
        ignoreHistoryRef.current = false
      })

    dispatchHistory({ type: 'REDO', activeCanvas: currentEditTarget })
  }

  const pushHistory = useCallback(
    // TODO: Clear and reset event Fabric.js event handlers when changing canvas,
    // then we won't need to optionally pass target here.
    async (canvas, target = null) => {
      if (ignoreHistoryRef.current) return
      dispatchHistory({
        type: 'PUSH',
        activeCanvas: target || currentEditTarget,
        newState: canvas.toJSON(),
      })
    },
    [currentEditTarget],
  )

  return {
    undo,
    redo,
    canUndo,
    canRedo,
    spineHistory,
    frontHistory,
    backHistory,
    currentCanvasHistory,
    canvasHistory,
    dispatchHistory,
    ignoreHistoryRef,
    setDisableUndo,
    pushHistory,
  }
}
